var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"n-image-upload"},[_c('div',{staticClass:"image",attrs:{"id":"addImage"},on:{"click":_vm.selectFile}},[_c('div',{attrs:{"id":"preview"}},[(_vm.url)?_c('img',{attrs:{"src":_vm.url,"alt":""}}):_vm._e(),(!_vm.url && _vm.defaultI)?_c('img',{staticClass:"url",attrs:{"src":_vm.defaultI,"alt":""}}):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }